module.exports = __webpack_public_path__ + "static/img/58.fc41433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/58.png
// module id = CIZb
// module chunks = 0